export enum ClienteStatus {
    Ativo = 0,
    Inativo = 1,
}

export enum ClienteMoradia {
    CasaPropria = 0,
    Aluguel = 1,
    Empresado = 2,
    Outros = 3,
}

export enum ClienteSituacaoCadastro {
    Aprovado = 0,
    EmObservacao = 1,
    Bloqueado = 2,
    Inativo = 3,
    Spc = 4,
}

export enum ClienteFiscalPerfil {
    TodasOpcoes = 0,
    EmpresaVarejista = 1,
    EmpresaAtacadista = 2,
}

export enum ClienteCatalogoStatus {
    AcessoLiberado = 1,
    AguardandoAnalise = 2,
    AcessoBloqueado = 3,
    AguardandoConfirmacaoCodigo = 4,
    ContaEncerrada = 5,
}
